import { render, staticRenderFns } from "./OpenTradeins.vue?vue&type=template&id=f069984c&"
import script from "./OpenTradeins.vue?vue&type=script&lang=js&"
export * from "./OpenTradeins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports